/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import ReactOnRails from 'react-on-rails';

import rootComponentWrapper from '../bundles/Shared/rootComponentWrapper';

import Account from '../bundles/Account/components/Account';
import AdminDiscourse from '../bundles/DiscourseIndex/components/AdminDiscourse';
import AdminEnrollmentManagement from '../bundles/AdminEnrollmentManagement/components/AdminEnrollmentManagement';
import AllJobProspects from '../bundles/AllJobProspects/components/AllJobProspects';
import ArchivedJobProspects from '../bundles/ArchivedJobProspects/components/ArchivedJobProspects';
import BiopharmaGroup from '../bundles/BiopharmaGroup/components/BiopharmaGroup';
import BiopharmaGroups from '../bundles/BiopharmaGroups/components/BiopharmaGroups';
import Discourse from '../bundles/Discourse/components/Discourse';
import Event from '../bundles/Event/components/Event';
import Events from '../bundles/Event/components/Events';
import ExternalJobBoards from '../bundles/ExternalJobBoards/components/ExternalJobBoards';
import Feed from '../bundles/Feed/components/Feed';
import Group from '../bundles/GroupShow/components/Group';
import GroupMembers from '../bundles/GroupShow/components/GroupMembers';
import GroupJobProspects from '../bundles/GroupJobProspects/components/GroupJobProspects';
import GroupSettings from '../bundles/GroupShow/components/GroupSettings';
import GroupUserInvitations from '../bundles/GroupUserInvitations/components/GroupUserInvitations';
import IndexGroup from '../bundles/Group/components/IndexGroup';
import Interests from '../bundles/Interests/components/Interests';
import JobDescriptionsFromExternalWebsites from '../bundles/JobDescriptionsFromExternalWebsites/components/JobDescriptionsFromExternalWebsites';
import JobProspects from '../bundles/JobProspects/components/JobProspects';
import JobProspectsStats from '../bundles/JobProspectsStats/components/JobProspectsStats';
import LinkTextToAvoidInJobSearches from '../bundles/LinkTextToAvoidInJobSearches/components/LinkTextToAvoidInJobSearches';
import BiopharmaGroupsStats from '../bundles/JobProspectsStats/components/BiopharmaGroupsStats';
import ExternalJobBoardsStats from '../bundles/JobProspectsStats/components/ExternalJobBoardsStats';
import JobDescriptionsStats from '../bundles/JobProspectsStats/components/JobDescriptionsStats';
import MatchScoresStats from '../bundles/JobProspectsStats/components/MatchScoresStats';
import JobProspectsStatsDetail from '../bundles/JobProspectsStats/components/JobProspectsStatsDetail';
import UserPipelineDebug from '../bundles/JobProspectsStats/components/UserPipelineDebug';
import UserMatchScores from '../bundles/UserMatchScores/components/UserMatchScores';
import LandingPage from '../bundles/LandingPage/components/LandingPage';
import LegalDocument from '../bundles/Legal/components/LegalDocument';
import LegalIndex from '../bundles/Legal/components/LegalIndex';
import LoginRecords from '../bundles/LoginRecords/components/LoginRecords';
import SessionTokens from '../bundles/SessionTokens/components/SessionTokens';
import NewAccount from '../bundles/Account/components/NewAccount';
import Profile from '../bundles/User/components/Profile';
import PublishedDiscourse from '../bundles/DiscourseIndex/components/PublishedDiscourse';
import ResetAccountPassword from '../bundles/Account/components/ResetAccountPassword';
import Resume from '../bundles/Resume/components/Resume';
import { default as RestrictedActionIndex } from '../bundles/RestrictedAction/components/Index';
import { default as RestrictedActionShow } from '../bundles/RestrictedAction/components/Show';
import { default as RoleIndex } from '../bundles/Role/components/Index';
import { default as RoleShow } from '../bundles/Role/components/Show';
import Skills from '../bundles/Skills/components/Skills';
import StopEventInvites from '../bundles/Event/components/StopEventInvites';
import Tag from '../bundles/Tag/components/Tag';
import Tags from '../bundles/Tags/components/Tags';
import UserInvitations from '../bundles/UserInvitations/components/UserInvitations';
import UserJobProspects from '../bundles/UserJobProspects/components/UserJobProspects';
import { default as UserIndex } from '../bundles/User/components/Index';
import VirtualVenue from '../bundles/Event/components/VirtualVenue';
import YourDiscourse from '../bundles/DiscourseIndex/components/YourDiscourse';

ReactOnRails.register({
  Account: rootComponentWrapper(Account),
  AdminDiscourse: rootComponentWrapper(AdminDiscourse),
  AdminEnrollmentManagement: rootComponentWrapper(AdminEnrollmentManagement),
  AllJobProspects: rootComponentWrapper(AllJobProspects),
  ArchivedJobProspects: rootComponentWrapper(ArchivedJobProspects),
  BiopharmaGroup: rootComponentWrapper(BiopharmaGroup),
  BiopharmaGroups: rootComponentWrapper(BiopharmaGroups),
  Discourse: rootComponentWrapper(Discourse),
  Event: rootComponentWrapper(Event),
  Events: rootComponentWrapper(Events),
  ExternalJobBoards: rootComponentWrapper(ExternalJobBoards),
  Feed: rootComponentWrapper(Feed),
  Group: rootComponentWrapper(Group),
  GroupMembers: rootComponentWrapper(GroupMembers),
  GroupJobProspects: rootComponentWrapper(GroupJobProspects),
  GroupSettings: rootComponentWrapper(GroupSettings),
  GroupUserInvitations: rootComponentWrapper(GroupUserInvitations),
  IndexGroup: rootComponentWrapper(IndexGroup),
  Interests: rootComponentWrapper(Interests),
  JobProspects: rootComponentWrapper(JobProspects),
  JobProspectsStats: rootComponentWrapper(JobProspectsStats),
  BiopharmaGroupsStats: rootComponentWrapper(BiopharmaGroupsStats),
  ExternalJobBoardsStats: rootComponentWrapper(ExternalJobBoardsStats),
  JobDescriptionsStats: rootComponentWrapper(JobDescriptionsStats),
  MatchScoresStats: rootComponentWrapper(MatchScoresStats),
  JobProspectsStatsDetail: rootComponentWrapper(JobProspectsStatsDetail),
  UserPipelineDebug: rootComponentWrapper(UserPipelineDebug),
  UserMatchScores: rootComponentWrapper(UserMatchScores),
  JobDescriptionsFromExternalWebsites: rootComponentWrapper(JobDescriptionsFromExternalWebsites),
  LandingPage: rootComponentWrapper(LandingPage),
  LinkTextToAvoidInJobSearches: rootComponentWrapper(LinkTextToAvoidInJobSearches),
  LoginRecords: rootComponentWrapper(LoginRecords),
  SessionTokens: rootComponentWrapper(SessionTokens),
  NewAccount: rootComponentWrapper(NewAccount),
  Profile: rootComponentWrapper(Profile),
  PublishedDiscourse: rootComponentWrapper(PublishedDiscourse),
  LegalDocument: rootComponentWrapper(LegalDocument),
  LegalIndex: rootComponentWrapper(LegalIndex),
  ResetAccountPassword: rootComponentWrapper(ResetAccountPassword),
  Resume: rootComponentWrapper(Resume),
  RestrictedActionIndex: rootComponentWrapper(RestrictedActionIndex),
  RestrictedActionShow: rootComponentWrapper(RestrictedActionShow),
  RoleIndex: rootComponentWrapper(RoleIndex),
  RoleShow: rootComponentWrapper(RoleShow),
  Skills: rootComponentWrapper(Skills),
  StopEventInvites: rootComponentWrapper(StopEventInvites),
  Tag: rootComponentWrapper(Tag),
  Tags: rootComponentWrapper(Tags),
  UserInvitations: rootComponentWrapper(UserInvitations),
  UserJobProspects: rootComponentWrapper(UserJobProspects),
  UserIndex: rootComponentWrapper(UserIndex),
  VirtualVenue: rootComponentWrapper(VirtualVenue),
  YourDiscourse: rootComponentWrapper(YourDiscourse),
});
